import { getMessages } from '../../../../../../../store/constants';

export const COMMENT_ACTIONS_TOOLTIP = getMessages().getText('card_form_comments.actions.tooltip');
export const COMMENT_ACTION_EDIT = getMessages().getText('common.edit');
export const COMMENT_ACTION_REPLY = getMessages().getText('card_form_comments.action.reply');
export const COMMENT_ACTION_LINK = getMessages().getText('card_form_comments.action.link');
export const COMMENT_ACTION_DELETE = getMessages().getText('card_form_comments.action.delete');
